import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider, Frame } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";

import "@shopify/polaris/build/esm/styles.css";

const root = ReactDOM.createRoot(
	process.env.NODE_ENV === "production"
		? (document.getElementById("messageflow-react-app") as HTMLElement)
		: (document.getElementById("root") as HTMLElement),
);
root.render(
	<React.StrictMode>
		<AppProvider i18n={enTranslations}>
			<Frame>
				<App />
			</Frame>
		</AppProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
